"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushGtm = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dataLayer = (window.dataLayer = window.dataLayer || []);
const initGtm = (tagId) => {
    var _a;
    dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const first = document.getElementsByTagName("script")[0];
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtm.js?id=" + tagId;
    (_a = first.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, first);
};
if (location.hostname === "localhost") {
    initGtm("GTM-KQPKJBT"); // dev
}
else {
    initGtm("GTM-NX5F58K"); // prod
}
const pushGtm = (data) => {
    dataLayer.push(data);
};
exports.pushGtm = pushGtm;
